import { useDeviceType } from '@vfit/shared/hooks';
import { IconButton } from '@vfit/shared/atoms';
import { INavBar } from './navBar.models';
import * as S from './navBar.style';
import { useNavBar } from './navBar.hook';
import { colors } from '@vfit/shared/themes';

const NavBar = ({ backInApp = true, title, onClose, onBack, children }: INavBar) => {
  const { isInApp } = useNavBar({ backInApp });

  const { isMobile } = useDeviceType();

  return !isInApp ? (
    <>
      <S.Header className="navbar-header">
        <S.Nav>
          <IconButton
            name="arrowLeft"
            color="#0d0d0d"
            width={isMobile ? 32 : 36}
            onClick={onBack}
          />
          <S.Title className="navbar-title">{title}</S.Title>
          <IconButton
            name="close"
            color="#0d0d0d"
            width={isMobile ? 32 : 36}
            onClick={onClose}
            className="close-modal-web"
          />
        </S.Nav>
      </S.Header>
      {children}
    </>
  ) : (
    <>
      <S.Header bg={colors.$f2f2f2} compact className="navbar-header">
        <S.Nav>
          <IconButton
            className="back-button-from-app"
            variant="circle"
            name="arrowLeft"
            color="#fff"
            width={24}
            onClick={onClose}
          />
        </S.Nav>
      </S.Header>
      {children}
    </>
  );
};

export default NavBar;

